'use strict';

var App = require('app');
var BaseDeviceSettingsView = require('components/devices/views/common/base_device_settings_view');
var Consts = require('consts');
var Notification = require('utils/notification');
var Misc = require('utils/misc');
var i18n = require('utils/i18n');

var SettingsView = BaseDeviceSettingsView.extend({
    template: require('components/devices/templates/gateway/settings'),

    events: function () {
        return _.extend({}, BaseDeviceSettingsView.prototype.events, {
            'click button#js-check-replacement': 'checkReplacement',
        });
    },

    getInputFields: function () {
        return {
            name: {},
        };
    },

    getUpdatedModel: function (form) {
        return {
            name: form.devicename,
            replacementFor: parseInt(form.replacement_select) || 0,
        };
    },

    handleUpdatedModel: function (form) {
        form = this.getUpdatedModel(form);

        if (form.replacementFor != 0) {
            // custom handling for device replacement
            this.controller.deviceReplacement({
                replaced_id: form.replacementFor,
                new_id: this.model.id,
                mode: 'replace',

                success_cb: function (response) {
                    App.hideModal();
                    Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Gerät wurde ersetzt.'));
                },
                error_cb: function () {
                    App.hideModal();
                    Notification.show('error', i18n.TR('Fehler'), i18n.TR('Gerät konnte nicht ersetzt werde.'));
                },
            });

            // update (= replacement) was handled
            return true;
        }

        // forward to standard handling
        return false;
    },

    onShow: function () {
        this.initDevicePicker();
    },

    checkReplacement: function (e) {
        e.preventDefault();

        var replaced_id = parseInt($('#replacement_select-input').val());
        var new_id = this.formData.id;

        if (replaced_id > 0 && new_id > 0) {
            var $btn = $('#' + e.target.id);

            $btn.toggleClass('disabled');
            $btn.prop('disabled', true);
            $btn.html(Misc.spinnerHTML() + ' ' + i18n.TR('Prüfen'));

            var showResult = function (message, icon) {
                var html = message;
                if (icon !== undefined) {
                    html = '<i class="fa fa-' + icon + '"></i> ' + html;
                }

                $btn.html(html);
                $btn.toggleClass('disabled');
                $btn.prop('disabled', false);
            };

            var self = this;
            this.controller.deviceReplacement({
                replaced_id: replaced_id,
                new_id: new_id,
                mode: 'check',

                success_cb: function (response) {
                    // present results ..
                    if (response.consistent > 0) {
                        // .. found any matching device
                        showResult(i18n.TR('OK'), 'check success-plain');
                    } else {
                        // .. any other state -> unclear
                        showResult(i18n.TR('Unklar'), 'question warning-plain');
                    }
                },
                error_cb: function () {
                    showResult(i18n.TR('Fehler'), 'exclamation-triangle error-plain');
                },
            });
        }
    },

    initDevicePicker: function () {
        var self = this;
        Misc.initDevicePicker({
            selectFirst: false,
            hideIfEmpty: '#replacement_select_form',
            filter: function () {
                return {
                    connectable: true,
                    status: [
                        Consts.DeviceStatusURL.OK,
                        Consts.DeviceStatusURL.Warning,
                        Consts.DeviceStatusURL.Error,
                        Consts.DeviceStatusURL.Deactivated,
                    ],
                };
            },
        });
        $('#replacement_select-input').change(function (e) {
            // hide name configuration elements
            $('#devicename_form').hide();
            $('#replacement_select_hint').hide();

            // enable check button
            var $checkBtn = $('#js-check-replacement');
            $checkBtn.toggleClass('disabled');
            $checkBtn.prop('disabled', false);

            // insert dummy device name (to ensure valid form)
            $('#devicename-input').val('replacement');
        });
    },
});

module.exports = SettingsView;
